import { IeLynxObject } from "../../common/models/eLynxObject";
import { IDateRange } from "../../common/models/IDateRange";
import { TrendConfigurationModel } from "../../services/trending-configuration-data-service/Models";
import { ITrendingDisplayOptions } from "../../services/trending-data-service/Models";

export const keys = {
    all: ["object-graph"],
    data: (contextGroupID: number,
        eLynxObject: IeLynxObject | undefined,
        configuration: TrendConfigurationModel | undefined,
        configurationID: number | undefined,
        duration: IDateRange,
        displayOptions?: ITrendingDisplayOptions) => [
            ...keys.all,
            "graph-data", {
                contextGroupID,
                eLynxObject,
                configuration,
                configurationID,
                duration,
                displayOptions
            }
        ],
    fileStoreData: (
        contextGroupID: number,
        fileStoreID: number | undefined
    ) => [
            ...keys.all,
            "filestore-data", {
                contextGroupID,
                fileStoreID,
            }
        ],
    quickGraphSelections: (contextGroupID: number,
        eLynxObject: IeLynxObject | undefined) => [
            ...keys.all,
            "quick-graph-selections", {
                contextGroupID,
                eLynxObject
            }
        ],

    tabularData: (
        groupID: number,
        targetObject: IeLynxObject,
        configurationID: number,
        startTime?: Date,
        endTime?: Date
    ) => [
            ...keys.all,
            "graph-tabular-data", {
                groupID,
                targetObject,
                configurationID,
                startTime,
                endTime
            }
        ]
};

